
import React from 'react'
import {connect} from 'react-redux'
import Document from './Document'
import Spinner from './Spinner'
import {
  changeOrientation,
  fetchFloorPicker,
  fetchMapDocument,
  fetchUnits,
  receiveAndApplyFilterChange
} from '../actions'

class App extends React.Component {

  constructor(props) {
    super(props)

    this.state = this.getWidthAndHeight()

    const {
        config
    } = this.props

    if (config.layout === 'highrise') {
      this.props.dispatch(fetchFloorPicker(config.highrise.floorpicker.unitmap.path))
    }
    this.props.dispatch(fetchMapDocument(config.unitmap.path))
    this.props.dispatch(fetchUnits(config.unitsUrl))

    this.handleFilterChange = this.handleFilterChange.bind(this)
    this.handleResize = this.handleResize.bind(this)
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.document !== this.props.document
      || nextProps.filteredUnits !== this.props.filteredUnits
      || nextProps.filters !== this.props.filters
      || nextState.orientation !== this.state.orientation
      || nextState.height !== this.state.height
      || nextState.width !== this.state.width
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  /**
   * Each browser rounds pixels different (http://cruft.io/posts/percentage-calculations-in-ie/).
   * Some browsers handle fractional pixels on their own (Chrome and Firefox),
   * while others do not (IE).  This is a fix to check if browser rounded up,
   * if so, account for the extra pixel they are saying we have, even though we
   * do not.
   *
   * @return {Object} The height and width pixel values
   */
  getWidthAndHeight() {
    let bounds = document.body.getBoundingClientRect()
    return {
      width: window.innerWidth === Math.floor(bounds.width) ?
        window.innerWidth : window.innerWidth - 1,
      height: window.innerHeight === Math.floor(bounds.height) ?
        window.innerHeight : window.innerHeight - 1,
    }
  }

  handleFilterChange(event) {
    this.props.dispatch(receiveAndApplyFilterChange(event.valueFor, event.value))
  }

  handleResize(event) {
    this.props.dispatch(changeOrientation())
    this.setState(this.getWidthAndHeight())
  }

  render() {
    const {
      config,
      document,
      filteredUnits,
      floorPicker
    } = this.props

    const {
      height,
      width
    } = this.state

    return (document && filteredUnits && (floorPicker || config.layout !== 'highrise'))
      ? <Document {...this.props} width={width} height={height} onChange={this.handleFilterChange} onFilterReset={this.handleFilterReset} />
      : <Spinner />
  }
}

// Which props do we want to inject, given the global state?
// Note: use https://github.com/faassen/reselect for better performance.
function mapStateToProps(state) {
  return state.toObject()
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(App)
// export default App
